import createLucideIcon from '../createLucideIcon';

const ArrowRight = createLucideIcon('ArrowRightIcon', [
  ['line', { x1: '5', y1: '12', x2: '19', y2: '12', key: '1smlys' }],
  ['polyline', { points: '12 5 19 12 12 19', key: 'sfr3i6' }],
]);

export default ArrowRight;
